module.exports = __webpack_public_path__ + "img/Avatar-6.1a6859ef.svg";